import { useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "../../data/mock";

const LINKS = [
  { label: "Products", href: "#products" },
  { label: "Results", href: "#proof" },
  { label: "How it works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[min(1180px,calc(100%-2rem))]" data-testid="navbar">
      <div className="rounded-3xl md:rounded-full border border-white/10 bg-[#0b0d10]/90 backdrop-blur-xl px-5 sm:px-7 py-3">
        <div className="flex items-center justify-between">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap font-heading text-sm sm:text-lg tracking-tight text-white" data-testid="navbar-logo">
            <img src={BRAND.logoUrl} alt="Tap 4 Reviews logo" className="h-8 w-auto object-contain" />
            {BRAND.logoFirst}<span className="text-[#2f7fff]">{BRAND.logoAccent}</span>{BRAND.logoSecond}
          </a>
          <div className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm text-zinc-400 hover:text-white transition-colors"
                data-testid={`navbar-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <a
              href="#products"
              className="whitespace-nowrap rounded-full bg-[#2f7fff] hover:bg-[#4b91ff] text-white text-xs sm:text-sm font-semibold px-4 sm:px-5 py-2.5 transition-colors"
              data-testid="navbar-cta-button"
            >
              Get access
            </a>
            <button
              onClick={() => setOpen(!open)}
              className="md:hidden rounded-full border border-white/15 p-2 text-white"
              aria-label="Toggle menu"
              data-testid="navbar-mobile-menu-button"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
        {open && (
          <div className="md:hidden mt-3 flex flex-col gap-1 border-t border-white/10 pt-3 pb-1" data-testid="navbar-mobile-menu">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-xl px-3 py-2.5 text-sm text-zinc-300 hover:bg-white/5 hover:text-white transition-colors"
                data-testid={`navbar-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};
